(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const bootstrapToggle = require('bootstrap-toggle');

    function setBootstrapToggleState(element, value) {
        let disabled = $(element).prop('disabled');
        $(element).bootstrapToggle('enable');
        $(element).bootstrapToggle(value ? 'on' : 'off');
        if (disabled)
            $(element).bootstrapToggle('disable');
    }

    ko.bindingHandlers.bootstrapToggle = {
        init: function (element, valueAccessor) {
            $(element).bootstrapToggle();
            setBootstrapToggleState(element, ko.utils.unwrapObservable(valueAccessor()));
            $(element).on('change', function () {
                valueAccessor()($(this).prop('checked'));
            });
        },
        update: function (element, valueAccessor) {
            let vStatus = $(element).prop('checked');
            let vmStatus = ko.utils.unwrapObservable(valueAccessor());
            if (vStatus !== vmStatus)
                setBootstrapToggleState(element, vmStatus);
        }
    };
})();


// WEBPACK FOOTER //
// ./resources/scripts/bindings/ko.bootstrapToggle.js